import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	playedHands: 0,
	correctAnswers: [],
	wrongAnswers: 0,
	wonStreaks: 0,
	totalEvMistakes: 0,
	averageEvMistakes: 0,
	bestMoves: 0,
	blunder: 0,
	heroActions: {
		F: [],
		'X/C': [],
		'B/R': [],
		A: [],
	},
	gtoActionsStats: {
		F: [],
		'X/C': [],
		'B/R': [],
		A: [],
	},
	oneHandSession: {
		playedHands: 1,
		correctAnswers: [],
		wrongAnswers: 0,
		totalEvMistakes: 0,
		bestMoves: 0,
		blunder: 0,
	},
}

const trainerSession = createSlice({
	initialState,
	name: 'trainerSession',
	reducers: {
		setSessionData(state, action) {
			const { totalEv, averageEv, playedHands, wrongAnswer, correctAnswer, wonStreak, oneHandSessionData } =
				action.payload
			state.totalEvMistakes = totalEv
			state.averageEvMistakes = averageEv
			state.playedHands = playedHands
			state.wrongAnswers = wrongAnswer
			state.wonStreaks = wonStreak
			state.correctAnswers = correctAnswer
			state.oneHandSession.totalEvMistakes = oneHandSessionData.totalEv
			state.oneHandSession.wrongAnswers = oneHandSessionData.wrongAnswer
		},
		setPlayedHands(state) {
			state.playedHands += 1
		},
		setHeroActions(state, action) {
			const { heroAction, actionGroup, rI } = action.payload
			state.heroActions[actionGroup] = [...state.heroActions[actionGroup], { action: heroAction, rI: rI }]
		},
		setGtoActionsStats(state, action) {
			const { actionGroup, rI, percent } = action.payload
			state.gtoActionsStats[actionGroup] = [...state.heroActions[actionGroup], { rI: rI, percent: percent }]
		},
		setCorrectAnswers(state, action) {
			state.correctAnswers = [...state.correctAnswers, action.payload]

			state.oneHandSession.correctAnswers = [...state.oneHandSession.correctAnswers, action.payload]
		},
		setBestMove(state) {
			state.bestMoves += 1
			state.oneHandSession.bestMoves += 1
		},
		setBlunder(state) {
			state.blunder += 1
			state.oneHandSession.blunder += 1
		},
		setWrongAnswers(state, action) {
			state.wrongAnswers = [...state.wrongAnswers, action.payload]
			state.oneHandSession.wrongAnswers = [...state.oneHandSession.wrongAnswers, action.payload]
		},
		setWonStreaks(state, action) {
			state.wonStreaks = [...state.wonStreaks, action.payload]
		},
		resetSessionStats(state) {
			Object.assign(state, initialState)
		},
		resetOneHandSessionStats(state) {
			state.oneHandSession.correctAnswers = []
			state.oneHandSession.wrongAnswers = 0
			state.oneHandSession.totalEvMistakes = 0
			state.oneHandSession.bestMoves = 0
			state.oneHandSession.blunder = 0
		},
	},
})

export const setSessionData =
	(totalEv, averageEv, playedHands, wrongAnswer, wonStreak, oneHandSessionData, correctAnswer) => (dispatch) => {
		dispatch(
			actions.setSessionData({
				totalEv,
				averageEv,
				playedHands,
				wrongAnswer,
				wonStreak,
				correctAnswer,
				oneHandSessionData,
			})
		)
	}

export const setHeroActions =
	({ heroAction, actionGroup, rI }) =>
	(dispatch) => {
		dispatch(actions.setHeroActions({ heroAction, actionGroup, rI }))
	}

export const setBestMove = () => (dispatch) => {
	dispatch(actions.setBestMove())
}

export const setBlunder = () => (dispatch) => {
	dispatch(actions.setBlunder())
}

export const resetOneHandSessionStats = () => (dispatch) => {
	dispatch(actions.resetOneHandSessionStats())
}

export const resetSessionStats = () => (dispatch) => {
	dispatch(actions.resetSessionStats())
}

export const { reducer } = trainerSession
const { actions } = trainerSession
